<mat-tab-group mat-stretch-tabs="false" animationDuration="0ms">
	<mat-tab label="Detail"> <app-patient-detail></app-patient-detail></mat-tab>
	<mat-tab label="Appointments"> <app-patient-appointments></app-patient-appointments></mat-tab>
</mat-tab-group>
